// Import the functions you need from the SDKs you need
export const DB_CONFIG = {
  apiKey: "AIzaSyC9FUIdI-Y-ID0UeMds7UV_KZZce1lgbWY",
  authDomain: "flashcards-de24d.firebaseapp.com",
  projectId: "flashcards-de24d",
  storageBucket: "flashcards-de24d.appspot.com",
  messagingSenderId: "355962930632",
  appId: "1:355962930632:web:8ffccf74510af84c392cfd",
  measurementId: "G-WN6NZFKH6J",
};
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
